import { useEffect } from "react";

const BASE_TITLE =
  "International Sci Ink Press — Advancing Medical Knowledge Through Open Science";

/**
 * Tiny client-side document.title helper for routed sub-pages.
 * Sets the title on mount and resets it on unmount.
 */
export default function usePageTitle(suffix) {
  useEffect(() => {
    if (suffix) {
      document.title = `${suffix} · International Sci Ink Press`;
    }
    return () => {
      document.title = BASE_TITLE;
    };
  }, [suffix]);
}
